var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58464 18.1263C4.8763 18.1263 1.04297 14.293 1.04297 9.58464C1.04297 4.8763 4.8763 1.04297 9.58464 1.04297C14.293 1.04297 18.1263 4.8763 18.1263 9.58464C18.1263 14.293 14.293 18.1263 9.58464 18.1263ZM9.58464 2.29297C5.55964 2.29297 2.29297 5.56797 2.29297 9.58464C2.29297 13.6013 5.55964 16.8763 9.58464 16.8763C13.6096 16.8763 16.8763 13.6013 16.8763 9.58464C16.8763 5.56797 13.6096 2.29297 9.58464 2.29297Z",
    fill: "#002857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3326 18.9576C18.1742 18.9576 18.0159 18.8992 17.8909 18.7742L16.2242 17.1076C15.9826 16.8659 15.9826 16.4659 16.2242 16.2242C16.4659 15.9826 16.8659 15.9826 17.1076 16.2242L18.7742 17.8909C19.0159 18.1326 19.0159 18.5326 18.7742 18.7742C18.6492 18.8992 18.4909 18.9576 18.3326 18.9576Z",
    fill: "#002857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlueIcon);
export default __webpack_public_path__ + "static/media/search_blue_icon.28213e922acbf4306426cfab4bec0a64.svg";
export { ForwardRef as ReactComponent };